import React, { useState, useEffect } from 'react';
import '../../styles/admin/ProductFormModal.css';

const ProductFormModal = ({ show, product, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    barcode: '',
    name: '',
    type: 'fixed',
    price: 0,
    pricePerKg: 0,
    stockQty: 0
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (product) {
      setFormData(product);
    } else {
      setFormData({
        barcode: '',
        name: '',
        type: 'fixed',
        price: 0,
        pricePerKg: 0,
        stockQty: 0
      });
    }
    setErrors({});
  }, [product, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name === 'type' ? value : (name === 'barcode' || name === 'name' ? value : Number(value))
    }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validate = () => {
    const newErrors = {};
    
    if (!formData.barcode.trim()) {
      newErrors.barcode = 'Barcode is required';
    }
    
    if (!formData.name.trim()) {
      newErrors.name = 'Product name is required';
    }
    
    if (formData.type === 'fixed' && formData.price <= 0) {
      newErrors.price = 'Price must be greater than 0';
    }
    
    if (formData.type === 'weight' && formData.pricePerKg <= 0) {
      newErrors.pricePerKg = 'Price per kg must be greater than 0';
    }
    
    if (formData.stockQty < 0) {
      newErrors.stockQty = 'Stock quantity cannot be negative';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      onSave(formData);
    }
  };

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="product-form-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            <i className={`fas ${product ? 'fa-edit' : 'fa-plus-circle'}`}></i>
            {product ? 'Edit Product' : 'Add New Product'}
          </h2>
          <button className="close-btn" onClick={onCancel}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="product-form">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="barcode">
                <i className="fas fa-barcode"></i>
                Barcode *
              </label>
              <input
                type="text"
                id="barcode"
                name="barcode"
                value={formData.barcode}
                onChange={handleChange}
                className={errors.barcode ? 'error' : ''}
                placeholder="Enter barcode"
              />
              {errors.barcode && <span className="error-text">{errors.barcode}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="name">
                <i className="fas fa-tag"></i>
                Product Name *
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={errors.name ? 'error' : ''}
                placeholder="Enter product name"
              />
              {errors.name && <span className="error-text">{errors.name}</span>}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="type">
                <i className="fas fa-list"></i>
                Product Type *
              </label>
              <select
                id="type"
                name="type"
                value={formData.type}
                onChange={handleChange}
              >
                <option value="fixed">Fixed Price</option>
                <option value="weight">Weight Based</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="stockQty">
                <i className="fas fa-cubes"></i>
                Stock Quantity *
              </label>
              <input
                type="number"
                id="stockQty"
                name="stockQty"
                value={formData.stockQty}
                onChange={handleChange}
                className={errors.stockQty ? 'error' : ''}
                placeholder="Enter stock quantity"
                min="0"
              />
              {errors.stockQty && <span className="error-text">{errors.stockQty}</span>}
            </div>
          </div>

          <div className="form-row">
            {formData.type === 'fixed' ? (
              <div className="form-group">
                <label htmlFor="price">
                  <i className="fas fa-dollar-sign"></i>
                  Price (LKR) *
                </label>
                <input
                  type="number"
                  id="price"
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                  className={errors.price ? 'error' : ''}
                  placeholder="Enter price"
                  min="0"
                  step="0.01"
                />
                {errors.price && <span className="error-text">{errors.price}</span>}
              </div>
            ) : (
              <div className="form-group">
                <label htmlFor="pricePerKg">
                  <i className="fas fa-weight"></i>
                  Price per Kg (LKR) *
                </label>
                <input
                  type="number"
                  id="pricePerKg"
                  name="pricePerKg"
                  value={formData.pricePerKg}
                  onChange={handleChange}
                  className={errors.pricePerKg ? 'error' : ''}
                  placeholder="Enter price per kg"
                  min="0"
                  step="0.01"
                />
                {errors.pricePerKg && <span className="error-text">{errors.pricePerKg}</span>}
              </div>
            )}
          </div>

          <div className="form-actions">
            <button type="button" className="cancel-btn" onClick={onCancel}>
              <i className="fas fa-times"></i>
              Cancel
            </button>
            <button type="submit" className="save-btn">
              <i className="fas fa-save"></i>
              {product ? 'Update Product' : 'Add Product'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProductFormModal;